module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAA8CAYAAAAUufjgAAAAAXNSR0IArs4c6QAAAUVJREFUaEPtmiFLREEUhb+Doj9Ai5oNdrvBoE2LybjZJvsfBKNRTDaLNg0Gs3aD2U3aXRCujKtgWO7CGwYeeF6ed+e8b+6dOW+4AoiIeeAYOADWgWfgEjiTFGVMqyciBBwBh8AG8AJcAaeSPhURc8A9sDVFxI2k/VbifuBcA3tT5ngAtovAIXCSiBhIumghMiIGwHkSe1gEPgKbyaA7SbuNBN4CO0nspyJwDCwkg0aS1hoJHAErSexxETirCN4lLTcS+AYsZbEtMKMTESZYlZomWIVvcsQ6B6sgmmAVPudgLT4TNMEJAdst2y3Alt//JF23RLuZruR+3zNBE/RZPCMHXCQuEheJi2RCwIbVhrXrfuiTpCs5G9ZaciZogn8I+PrtX1y/fQCLyZe2bAl4BVaTub9bAnrfVNH7tpR+N/aU9e9za9QXPx8r8WEe8+wAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/video/iv_pause.png
// module id = 17FX
// module chunks = 1